import { render, staticRenderFns } from "./BtDatesModel.vue?vue&type=template&id=57fc913f&scoped=true&"
import script from "./BtDatesModel.vue?vue&type=script&lang=js&"
export * from "./BtDatesModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fc913f",
  null
  
)

export default component.exports